<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data.title"
      [subheader]="data.p1"
      [imageUrl]="data.avatar_url"
      [imageAlt]="data.title"
    />
  </ng-container>

  <ng-container body>
    <table cellpadding="0" cellspacing="0" border="0" class="web-desktop-only">
      <tr>
        <td width="100"><email-codebox [code]="data.code" [inline]="true" /></td>
        <td width="20"></td>
        <td><email-link [href]="data.confirm_url" [label]="data.confirm_label" /></td>
      </tr>
    </table>

    <!--[if !mso]><\!-->
    <table cellpadding="0" cellspacing="0" border="0" class="web-mobile-only">
      <tr>
        <td width="100"><email-codebox [code]="data.code" /></td>
      </tr>
      <tr>
        <td><email-margin [height]="14" /></td>
      </tr>
      <tr>
        <td><email-button [href]="data.confirm_url" [label]="data.confirm_label" /></td>
      </tr>
    </table>
    <!-- <![endif]-->

    <email-margin [height]="28" />
    <email-text
      [contents]="data.p2 | mailgunMarkAsHtml"
      presetName="paragraph"
      size="small"
      color="light"
    />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
